import urlRoute from '../../common/service/urlRoute';
import { ROUTES } from '../../common/constants/routes';
import carUrlQueryTransformer from '../../common/service/carUrlQueryTransformer';
import { IBuiltCar } from '../../../../common/model/IBuiltCar';

const configurationSourceUrlService = {
  getUrl: (
    basePath: string,
    modelId: string,
    carId: string,
    car: IBuiltCar,
    route: string = ROUTES.CONFIGURE,
  ): string => {
    const query = carUrlQueryTransformer.toQueryString(car);
    return (
      urlRoute.joinUrl(window.origin, basePath, urlRoute.createUrl(decodeURI(route), { modelId, carId })) +
      (query === '' ? '' : '?' + query)
    );
  },
};

export default configurationSourceUrlService;
